import React from 'react';
import './Baner.css'


const Baner = ({ image, description }) => {
    return (
        <>
            {image && <img src={image} alt="Category banner" />}
            <p>{description}</p>
        </>
    );
};

export default Baner;